import React, { useState, useContext } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns, userRows } from "../datatablesource";
import { Link } from "react-router-dom";
import { Plus } from "tabler-icons-react";
import { MenuContext } from "../context/menuContext";

function Users() {
	const [data, setData] = useState(userRows);
	const { mobileMenu } = useContext(MenuContext);

	const handleDelete = (id) => {
		setData(data.filter((items) => items.id !== id));
	};

	const actionColumn = [
		{
			field: "action",
			headerName: "Action",
			width: 150,
			renderCell: (params) => {
				return (
					<div className="flex space-x-2">
						<Link to="/users/:id" style={{ textDecoration: "none" }}>
							<div className="bg-green-200 px-2 rounded-md text-slate-600">
								View
							</div>
						</Link>
						<div
							className="bg-red-200 px-2 rounded-md text-slate-600 cursor-pointer"
							onClick={() => handleDelete(params.row.id)}>
							Delete
						</div>
					</div>
				);
			},
		},
	];

	return (
		<div
			className={
				mobileMenu
					? "overflow-y-hidden absolute md:left-64 md:top-0 w-screen md:w-[calc(100%-16rem)] py-3 h-screen bg-slate-50 dark:bg-darkbg"
					: "absolute md:left-[13rem] lg:left-64 md:top-0 w-screen md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] py-3 h-screen top-[3rem] bg-slate-50 dark:bg-darkbg"
			}>
			<div className="flex justify-between items-baseline px-5 border-b border-b-slate-100 dark:border-darkborder">
				<h1 className="text-slate-500 dark:text-darktext uppercase font-semibold">
					Users
				</h1>
				<Link
					to="/users/new"
					className="flex items-center border border-sky-200 dark:border-darkborder px-3 py-1 text-slate-600 dark:text-darktext rounded-sm hover:bg-sky-500 dark:hover:bg-darkbtn hover:text-white transition-all duration-150 ease-in-out">
					<Plus className="mr-1" /> Add user
				</Link>
			</div>
			<div className="px-5 h-full">
				<DataGrid
					className="h-full mt-3 shadow-sm bg-white dark:bg-darkbg dark:border-darkborder dark:text-darktext"
					rows={data}
					columns={userColumns.concat(actionColumn)}
					pageSize={99}
					rowsPerPageOptions={[99]}
					checkboxSelection
				/>
			</div>
		</div>
	);
}

export default Users;
